import { useNavigate } from "@opendash/router";
import { Button, Divider } from "antd";
import React from "react";
import ReactMarkdown from "react-markdown";
import ReactPlayer from "react-player";
import styled from "styled-components";

import { useTranslation } from "@opendash/core";
import { $parse } from "@opendash/plugin-parse";
import { createComponent } from "@opendash/state";
import type { AppState } from "./App.state";
import { ActionBar } from "./styles";

const ReactPlayerContainer = styled.div`
  position: relative;
  padding-top: 56.25%; /* Player ratio: 100 / (1280 / 720) */

  > div {
    position: absolute;
    top: 0;
    left: 0;
  }
`;

export const KnowledgeVideoView = createComponent(function KnowledgeVideoView({
  state,
}: {
  state: AppState;
}) {
  const t = useTranslation();
  const navigate = useNavigate();

  if (!state.video) {
    return null;
  }

  state.useForceRender();

  return (
    <>
      {$parse.ui.getObjectPermission(state.video, "update") && (
        <ActionBar>
          {$parse.ui.getObjectPermission(state.video, "update") && (
            <Button
              children={t("knowledge:label.update_video")}
              onClick={() => {
                state.updateContent(state.video);
              }}
            />
          )}
          {$parse.ui.getObjectPermission(state.video, "delete") && (
            <Button
              danger
              children={t("knowledge:label.delete_video")}
              onClick={() => {
                state.deleteContent(state.video).then((deleted) => {
                  if (deleted) {
                    navigate("../..");
                  }
                });
              }}
            />
          )}
        </ActionBar>
      )}
      <ReactPlayerContainer>
        <ReactPlayer
          controls
          playing={true}
          volume={1}
          muted={true}
          width="100%"
          height="100%"
          url={state.video.video?.url()}
        />
      </ReactPlayerContainer>
      <Divider />
      <ReactMarkdown children={state.video.descriptionMarkdown} />
    </>
  );
});
